export const LC_PASSAGE_MAPPING = {
    BOY: {
        KG: {
            passages: [
                { id: '1000000', title: 'Dinner with Friends' },
                { id: '1000001', title: 'Kim Learns to Ride a Bike' },
                { id: '1000002', title: 'Animals in Africa' },
                { id: '1000003', title: 'Breakfast Around the World' },
            ],
        },
        '01': {
            passages: [
                { id: '1000004', title: 'A School Project' },
                { id: '1000005', title: 'Sharing Milo' },
                { id: '1000006', title: 'Solar Energy' },
                { id: '1000007', title: 'Physical Activity' },
            ],
        },
    },
    MOY: {
        KG: {
            passages: [
                { id: '1100000', title: 'Mystery of the Lost Earrings' },
                { id: '1100001', title: 'The Alligator and the Raccoon' },
                { id: '1100002', title: 'The Instruments in an Orchestra' },
                { id: '1100003', title: 'The Flying Squirrel' },
            ],
        },
        '01': {
            passages: [
                { id: '1100004', title: 'Beaver Business' },
                { id: '1100005', title: 'A Camping Trip' },
                { id: '1100006', title: 'Tornadoes' },
                { id: '1100007', title: 'Jigsaw Puzzles' },
            ],
        },
    },
};

export const FIRST = 'first';

export const SECOND = 'second';

export const LC_PASSAGE_HALF_INDEX_MAPPING = {
    [FIRST]: 0,
    [SECOND]: 1,
};

export const FINAL_LC_RESULT_INDEX = 1;

export default LC_PASSAGE_MAPPING;
